import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4feee01a")

_pushScopeId("data-v-4feee01a")
const _hoisted_1 = { class: "LTLFilters" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "LTLFilters__divider" }, [
  /*#__PURE__*/_createVNode("span", { class: "LTLFilters__line" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "LTLFilters__divider" }, [
  /*#__PURE__*/_createVNode("span", { class: "LTLFilters__line" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "LTLFilters__divider" }, [
  /*#__PURE__*/_createVNode("span", { class: "LTLFilters__line" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_radio_buttons = _resolveComponent("s-radio-buttons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_s_radio_buttons, {
      options: _ctx.HISTORY_FILTERS_TYPES,
      "can-unselect": false,
      value: _ctx.historyFiltersState.data_type,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.historyFiltersState.data_type = $event)),
      onChange: _ctx.onViewTypeChange
    }, null, 8, ["options", "value", "onChange"]),
    _hoisted_3,
    _createVNode(_component_s_radio_buttons, {
      options: _ctx.HISTORY_FILTERS_LTL_STATUSES,
      value: _ctx.LTLFiltersState.status,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.LTLFiltersState.status = $event)),
      onChange: _ctx.onStatusChange
    }, null, 8, ["options", "value", "onChange"]),
    (
                _ctx.historyFiltersState.data_type && _ctx.historyFiltersState.data_type.value === 'invoices'
            )
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _hoisted_4,
          _createVNode(_component_s_radio_buttons, {
            options: _ctx.HISTORY_FILTERS_LTL_TYPES,
            value: _ctx.LTLFiltersState.type,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.LTLFiltersState.type = $event)),
            onChange: _ctx.onTypeChange
          }, null, 8, ["options", "value", "onChange"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
})